module.exports = __webpack_public_path__ + "static/media/omkar_thorat.e65901d6.jpg";